<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-2" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>TK Devre Raporu</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>



              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>


            </v-toolbar>
          </v-flex>
          <!-- <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 sm12 md4>
                <v-card>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon>assignment</v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>
                          <h3 class=" .font-weight-regular info--text mb-4">Devir</h3>
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>

                        <v-icon></v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-divider inset></v-divider>

                    <v-list-tile>
                      <v-layout row wrap>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                        <v-layout>
                          <v-flex sm3>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                Borç
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                          <v-flex sm8>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                :{{ devirborc }} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                      </v-layout>
                    </v-list-tile>


                    <v-list-tile>
                      <v-layout row wrap>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                        <v-layout>
                          <v-flex sm3>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                Alacak
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                          <v-flex sm8>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                :{{ deviralacak }} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                      </v-layout>
                    </v-list-tile>


                    <v-divider inset></v-divider>


                    <v-list-tile>
                      <v-layout row wrap>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                        <v-layout>
                          <v-flex sm3>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                Bakiye
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                          <v-flex sm8>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                :{{ devirbakiye }} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                      </v-layout>
                    </v-list-tile>


                  </v-list>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-card>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon>assignment</v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>
                          <h3 class=" .font-weight-regular info--text mb-4">Dönem</h3>
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>

                        <v-icon></v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-divider inset></v-divider>

                    <v-list-tile>
                      <v-layout row wrap>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                        <v-layout>
                          <v-flex sm3>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                Borç
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                          <v-flex sm8>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                :{{ donemborc }} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                      </v-layout>
                    </v-list-tile>


                    <v-list-tile>
                      <v-layout row wrap>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                        <v-layout>
                          <v-flex sm3>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                Alacak
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                          <v-flex sm8>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                :{{ donemalacak }} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                      </v-layout>
                    </v-list-tile>


                    <v-divider inset></v-divider>


                    <v-list-tile>
                      <v-layout row wrap>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                        <v-layout>
                          <v-flex sm3>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                Bakiye
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                          <v-flex sm8>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                :{{ donembakiye }} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                      </v-layout>
                    </v-list-tile>


                  </v-list>
                </v-card>
              </v-flex>


              <v-flex xs12 sm12 md4>
                <v-card>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon>assignment</v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>
                          <h3 class=" .font-weight-regular info--text mb-4">Toplam</h3>
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>

                        <v-icon></v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-divider inset></v-divider>

                    <v-list-tile>
                      <v-layout row wrap>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                        <v-layout>
                          <v-flex sm3>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                Borç
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                          <v-flex sm8>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                :{{ toplamborc }} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                      </v-layout>
                    </v-list-tile>


                    <v-list-tile>
                      <v-layout row wrap>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                        <v-layout>
                          <v-flex sm3>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                Alacak
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                          <v-flex sm8>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                :{{ toplamalacak }} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                      </v-layout>
                    </v-list-tile>


                    <v-divider inset></v-divider>


                    <v-list-tile>
                      <v-layout row wrap>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                        <v-layout>
                          <v-flex sm3>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                Bakiye
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                          <v-flex sm8>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                :{{ toplambakiye }} &#8378;
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                        <v-list-tile-action>
                          <v-icon></v-icon>
                        </v-list-tile-action>
                      </v-layout>
                    </v-list-tile>


                  </v-list>
                </v-card>
              </v-flex>









            </v-layout>
          </v-container> -->

          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="500px">
            <v-card color="grey lighten-2">
              <v-card-title>Filtre Seçimi</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm6 md12>
                    <v-layout justify-space-between column>
                      <havayollaricomp :etiket="'Hava Yolu Kodu'" v-model="havayolubil"></havayollaricomp>
                      <v-select :items="masrafmerkezi" v-model="devreRaporu.Masraf" label="Masraf Merkezi" item-text="CodeName"
                        item-value="Code">
                        <template slot="selection" slot-scope="{ item, index }">
                          <v-chip v-if="index === 0">
                            <h4> <span>{{ item.Code }}</span> </h4>
                          </v-chip>
                          <span v-if="index === 1" class="grey--text caption">(+{{
                            EkstreHesap.IstenmeyenReferanslar.length - 1 }} diğer kayıt)</span>
                        </template>
                      </v-select>
                    </v-layout>
                  </v-flex>


                  <v-flex xs12 sm12 md12>
                    <v-layout justify-space-between column>
                      <v-checkbox label="Sadece Acentadan Alınanları Bas" v-model="devreRaporu.Opsiyonlar.AcentaBas" hide-details=""></v-checkbox>
                      <v-checkbox label="Tüm Şirketler" v-model="tumsirketler" hide-details=""></v-checkbox>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <div class="card__text grey darken-1 white--text">
                      <h3>Seçenekler</h3>
                    </div>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-radio-group v-model="devreRaporu.RaporTipi" label="Rapor Tipi" column>
                      <v-radio label="Hepsi" :value="0"> </v-radio>
                      <v-radio label="Satış" :value="1"></v-radio>
                      <v-radio label="İade" :value="2"></v-radio>
                      <v-radio label="Void" :value="3"></v-radio>

                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-radio-group v-model="devreRaporu.OdemeSekli" label="Ödeme" column>
                      <v-radio label="Hepsi" :value="0"></v-radio>
                      <v-radio label="Peşin" :value="1"> </v-radio>
                      <v-radio label="Kredi Kartı" :value="2"> </v-radio>

                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-radio-group v-model="devreRaporu.SiraTipi" label="Rapor Sırası" column>
                      <v-radio label="Bilet Sırası (S-I-V)" :value="0"> </v-radio>
                      <v-radio label="Bilet Sırası" :value="1"> </v-radio>
                    </v-radio-group>
                  </v-flex>



                  <v-flex xs12 sm6 md4>
                    <v-radio-group v-model="devreRaporu.FiyatTur" label="Fiyat Türü" column>
                      <v-radio label="Tüm Biletler" :value="0"> </v-radio>
                      <v-radio label="KDV'siz Biletler" :value="1"></v-radio>
                      <v-radio label="KDV'li Biletler" :value="2"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-radio-group v-model="devreRaporu.HatTipi" label="Hat Tipi" column>
                      <v-radio label="Tümü" :value="0"> </v-radio>
                      <v-radio label="İç Hat" :value="1"></v-radio>
                      <v-radio label="Dış Hat" :value="2"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-radio-group v-model="devreRaporu.UcusTip" label="Kıbrıs/Batum Uçuşları" column>
                      <v-radio label="Tümü" :value="0"> </v-radio>
                      <v-radio label="ECN-BUS Hariç" :value="1"></v-radio>
                      <v-radio label="Sadece ECN-BUS" :value="2"></v-radio>
                    </v-radio-group>
                  </v-flex>






                </v-layout>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-container fluid="">
            <v-card  flat="" color="grey lighten-1" >
              <v-form ref="formcariyegore" v-model="valid" lazy-validation>
                <v-container fluid>
                  <v-card color="grey lighten-2" flat>
                  <v-layout row wrap="">

                    <v-flex xs12 sm6 md2>
                      <tarihcomp :etiket="'Başlangıç Tarihi'" :tabindex="'14'" v-bind:defaultvalue="'ok'" v-bind:value="devreRaporu.BaslangicTarih"
                        :rules="[v => !!v || 'Lütfen tarih seçiniz']" v-model="devreRaporu.BaslangicTarih"></tarihcomp>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <tarihcomp :etiket="'Bitiş Tarihi'" :rules="[v => !!v || 'Lütfen tarih seçiniz']" :tabindex="'14'"
                        v-bind:defaultvalue="'ok'" v-bind:value="devreRaporu.BitisTarih" v-model="devreRaporu.BitisTarih"></tarihcomp>
                    </v-flex>



                    <v-flex>
                      <v-layout>
                        <div v-if="load1">
                          <v-btn color="info" @click="getList()" fab small="" dark>
                            <v-icon>search</v-icon>
                          </v-btn>
                        </div>
                        <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                          color="info" fab dark>
                          <v-icon>filter_list</v-icon>
                        </v-btn>
                        <v-tooltip bottom="" :activator="el" v-model="tooltip">
                          <span>Arama Filtresi Ekle</span>
                        </v-tooltip>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  </v-card>
                </v-container>

              </v-form>
              <v-layout>



                <v-flex xs12 sm12 md12>
                  <v-card>

                    <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                      :search="search3">
                      <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                      <template slot="items" slot-scope="props">

                        <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                        <td class="text-xs-left">{{ props.item.CariKod }}</td>
                        <td class="text-xs-left">{{ props.item.S}}</td>
                        <td class="text-xs-left">{{ props.item.C}}</td>
                        <td class="text-xs-left">{{ props.item.UcusTip}}</td>
                        <td class="text-xs-left">{{ props.item.Komisyonlu}}</td>
                        <td class="text-xs-left">{{ props.item.Komisyonsuz }}</td>
                        <td class="text-xs-left">{{ props.item.Vergi }}</td>
                        <td class="text-xs-left">{{ props.item.KA }}</td>
                      <td class="text-xs-left">{{ props.item.YFF }}</td>
                        <td class="text-xs-left">{{ props.item.ToplamTutar }}</td>
                        <td class="text-xs-left">{{ props.item.CezaTutar }}</td>
                        <td class="text-xs-left">{{ props.item.Yuzde }}</td>
                        <td class="text-xs-left">{{ props.item.Komisyon }}</td>
                        <td class="text-xs-left">{{ props.item.FaturaNo }}</td>
                        <td class="text-xs-left">{{ props.item.ExBiletNo }}</td>







                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                      </v-alert>
                    </v-data-table>
                  </v-card>
                  <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                    :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                    {{ text1 }}
                    <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                  </v-snackbar>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihcomp'
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"


  export default {
    data() {
      return {
        search: '',

        headers: [{
            text: 'Bilet No',
            value: 'BiletNo'
          },
          {
            text: 'Cari Kod',
            value: 'CariKod'
          },
          {
            text: 'S',
            value: 'S'
          },
          {
            text: 'C',
            value: 'C'
          },
          {
            text: 'Uçuş Tip',
            value: 'UcusTip'
          },
          {
            text: 'Komisyonlu',
            value: 'Komisyonlu'
          },
          ,
          {
            text: 'Komisyonsuz',
            value: 'Komisyonsuz'
          },
          {
            text: 'Vergi',
            value: 'Vergi'
          },
          {
            text: 'KA',
            value: 'KA'
          },
          {
            text: 'YFF',
            value: 'YFF'
          },
          ,
          {
            text: 'Toplam Tutar',
            value: 'ToplamTutar'
          },
          ,
          {
            text: 'Ceza Tutar',
            value: 'CezaTutar'
          },
          {
            text: 'Yüzde',
            value: 'Yuzde'
          },
          {
            text: 'Komisyon',
            value: 'Komisyon'
          },
          {
            text: 'Fatura No',
            value: 'FaturaNo'
          },
          {
            text: 'EX Bilet No',
            value: 'ExBiletNo'
          }
        ],


        havayolubil: {
          havayolukodu: null,
          formno: null
        },

        devreRaporu: {
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          HavayoluKodu: null,
          Masraf: null,
          OdemeSekli: 0, // 0 : Hepsi, 1: Peşin, 2: KrediKartli
          RaporTipi: 0, // 0 : Hepsi, 1 : Satış, 2: Iade, 3 : Void
          FiyatTur: 0, // 0 : Hepsi, 1 : KdvsizBilet, 2: Kdvli Bilet
          UcusTip: 0, // 0 : Hepsi, 1 : Ecn-Bus Haric vb, 2 : Sadece Ecn-Bus vb
          HatTipi: 0, // 0 : Hepsi, 1 : Ic hat, 2 : Dış hat
          SiraTipi: 0, // 0 : S-I-V, 1 : BiletSirası
          Opsiyonlar: {
            AcentaBas: false
          }
        },



        devirborc: 0,
        deviralacak: 0,
        devirbakiye: 0,
        donemborc: 0,
        donemalacak: 0,
        donembakiye: 0,
        toplamborc: 0,
        toplamalacak: 0,
        toplambakiye: 0,
        valid: true,
        statecari: [],
        searchcari: '',
        Carihesap: '',
        text1: null,
        loading: false,
        progress: false,
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        search3: '',
        dialogfiltre: false,
        hesapkodu: [],
        Referans: [],
        masrafmerkezi: [],


        tumsirketler: false,

        anahesap: [],
        hesapgurubu: [],
        evraktipi: [],
        mizan: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        tooltip: false,
        el: null,
      }
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      havayollaricomp
    },
    mounted() {
      this.el = this.$refs.fab.$el

    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    methods: {
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      carigetir: carigetir,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
    }
  }








  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }



    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })



  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.dialogfiltre = false


  }

  function getList() {

    if (this.$refs.formcariyegore.validate()) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler == true) {
        this.devreRaporu.SirketKodu = 0
      } else {
        this.devreRaporu.SirketKodu = credentials.SirketKodu
      }

      this.progress = true

      this.devreRaporu.HavayoluKodu=this.havayolubil.havayolukodu;

      var params = this.devreRaporu

      this.load1 = false

      this.$http.post(auth.API_URL + 'api/TicketPeriodReport/TKPeriodReport', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {


         if (response.body.BiletListe.length !=0 ) {
  this.progress = false;
         this.load1 = true;
         this.items=response.body.BiletListe;
       } else {
          this.text1 = 'Kayıt Bulunamadı.';
       this.snackbar = true;
        this.progress = false;
       this.load1 = true;
      this.items = [];
   }

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true

          this.load1 = true
          this.progress = false

        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        }
      })

    }



  }


   function getListHtml() {

    if (this.$refs.formcariyegore.validate()) {

      this.progress = true
      this.load1 = false


      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler == true) {
        this.devreRaporu.SirketKodu = 0
      } else {
        this.devreRaporu.SirketKodu = credentials.SirketKodu
      }



      this.devreRaporu.HavayoluKodu=this.havayolubil.havayolukodu;

      var params = this.devreRaporu


      this.$http
      .post(auth.API_URL + "api/TicketPeriodReport/TKPeriodReportHtml", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "TKDevre.html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })

    }



  }


   function getListExcel() {

    if (this.$refs.formcariyegore.validate()) {

      this.progress = true
      this.load1 = false


      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler == true) {
        this.devreRaporu.SirketKodu = 0
      } else {
        this.devreRaporu.SirketKodu = credentials.SirketKodu
      }



      this.devreRaporu.HavayoluKodu=this.havayolubil.havayolukodu;

      var params = this.devreRaporu


      this.$http
      .post(auth.API_URL + "api/TicketPeriodReport/TKPeriodReportExcel", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        },responseType: "arraybuffer"
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "TKDevre.xlsx";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })

    }



  }

  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }


  function beforeMount() {

    this.devreRaporu.BaslangicTarih = getDateNow()
    this.devreRaporu.BitisTarih = getDateNow()
  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }
</script>

<style>

</style>